<template>
  <div class="welcome-overlay">
    <div class="welcome-card">
      <div class="welcome-logo">
        <img :src="arkaLogo" alt="ARKA" class="welcome-logo-img" />
      </div>
      <p class="welcome-subtitle">
        Five simple steps to design your perfect solar system
      </p>

      <div class="welcome-steps">
        <div class="welcome-step" v-for="step in steps" :key="step.title">
          <div class="welcome-step-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect width="24" height="24" rx="6" fill="#EBF2FF"/>
              <path :d="step.icon" fill="#409EFF"/>
            </svg>
          </div>
          <div class="welcome-step-text">
            <h4 class="welcome-step-title">{{ step.title }}</h4>
            <p class="welcome-step-desc">{{ step.desc }}</p>
          </div>
        </div>
      </div>

      <button class="welcome-cta" @click="$emit('get-started')">
        Get Started
      </button>
    </div>
  </div>
</template>

<script>
import arkaLogo from '../../assets/ArkaLogo.svg';

export default {
  name: 'WelcomeCard',
  emits: ['get-started'],
  data() {
    return {
      arkaLogo,
      steps: [
        {
          title: 'Draw Roof Area',
          desc: 'Select each corner of the roof one by one to draw a polygon.',
          icon: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
        },
        {
          title: 'Mark Objects',
          desc: 'Select and draw the objects from the menu if present on the rooftop to mark them.',
          icon: 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 16H5V5h14v14zM7 12h2v5H7v-5zm4-3h2v8h-2V9zm4-3h2v11h-2V6z',
        },
        {
          title: 'Calculate Savings',
          desc: 'Calculate the savings by entering the monthly bill details.',
          icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm0-4h-2V7h2v8z',
        },
        {
          title: 'Save Your Design',
          desc: 'Complete the design without closing the browser/tab. Closing may cause the loss of data.',
          icon: 'M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4zm-5 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm3-10H5V5h10v4z',
        },
      ],
    };
  },
};
</script>

<style scoped>
.welcome-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
}

.welcome-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px 24px;
  width: 100%;
  max-width: 360px;
  margin: 0 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.welcome-logo {
  text-align: center;
  margin-bottom: 12px;
}

.welcome-logo-img {
  height: 48px;
  width: auto;
}

.welcome-subtitle {
  text-align: center;
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px;
  line-height: 1.5;
}

.welcome-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 28px;
}

.welcome-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.welcome-step-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EBF2FF;
  border-radius: 10px;
}

.welcome-step-text {
  flex: 1;
  min-width: 0;
}

.welcome-step-title {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

.welcome-step-desc {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.welcome-cta {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: #409EFF;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.welcome-cta:active {
  background: #3080e0;
}
</style>
